import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

export interface ToastActionPayload {
  actionLabel?: string;
}

const TONE_ICONS: Record<string, string> = {
  success: 'circle-check',
  error: 'circle-alert',
  warning: 'triangle-alert',
  info: 'info'
};

@Component({
  selector: 'ss-toast',
  templateUrl: './toast.component.html',
  host: {
    '[class]': 'toastClasses()',
    '[style.display]': 'displayStyle()',
    '(mouseenter)': 'stickAround()',
    '(mouseleave)': 'delayedHideToast()'
  },
  standalone: false
})
export class BrasaToastComponent extends Toast<ToastActionPayload> {
  private remainingTime = 0;

  override stickAround() {
    if (this.state() === 'removed' || !this.hideTime) return;
    this.remainingTime = Math.max(this.hideTime - Date.now(), 0);
    clearTimeout(this.timeout);
    clearInterval(this.intervalId);
  }

  override delayedHideToast() {
    if (this.state() === 'removed' || !this.remainingTime) return;
    const timeOut = this.options().timeOut || this.originalTimeout();
    this.hideTime = Date.now() + this.remainingTime;
    this.timeout = this.timeoutsService.setTimeout(() => this.remove(), this.remainingTime);
    this.remainingTime = 0;
    if (this.options().progressBar && timeOut) {
      this.intervalId = this.timeoutsService.setInterval(() => this.updateProgress(), 10);
    }
  }

  get tone(): string {
    return this.toastPackage.toastType.replace('toast-', '');
  }

  get icon(): string {
    return TONE_ICONS[this.tone] || 'info';
  }

  get actionLabel(): string {
    return this.options().payload?.actionLabel || '';
  }

  runAction(event: Event) {
    event.stopPropagation();
    this.toastPackage.triggerAction();
    this.remove();
  }

  dismiss(event: Event) {
    event.stopPropagation();
    this.remove();
  }
}
